import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Box, IconButton, Menu, MenuItem } from '@mui/material'
import { styled } from '@mui/material/styles'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

import { CancelDialog, AssignToDialog } from '../dialogs'
import { useModalContext } from '../../../../ui/modal'
import { useApplicationsCalls, useApplicationExports } from '../../hooks'

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  borderRadius: '50%',
  border: '1px solid',
  borderColor: theme.palette.grey[400],
  color: theme.palette.grey[400],
  backgroundColor: theme.palette.common.white,
}))

export const MoreActionsBtn = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const userRole = useSelector((state) => state.global.role)
  const selectedRows = useSelector((state) => state.applications.selectedRows)
  const totalElements = useSelector((state) => state.applications.pagination.total_solicitudes)
  const { mainExport, handleExportAll } = useApplicationExports()

  const {
    actions: { open },
  } = useModalContext()
  const { getApplications } = useApplicationsCalls()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpenActions = (event) => setAnchorEl(event.currentTarget)

  const handleCloseActions = () => setAnchorEl(null)

  const handleOpenModal = (option) => {
    const component = option === 'cancel' ? CancelDialog : AssignToDialog
    setAnchorEl(null)
    open({
      Component: component,
      data: { navigate, location, getApplications },
      type: 'responsive',
    })
  }

  const handleExport = () => {
    setAnchorEl(null)
    mainExport(selectedRows)
  }

  const handleExportAllRequest = () => {
    setAnchorEl(null)
    handleExportAll()
  }

  return (
    <Box>
      <StyledIconButton onClick={handleOpenActions} size="large">
        <MoreHorizIcon />
      </StyledIconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseActions}>
        <MenuItem disabled={!selectedRows.length} onClick={() => handleExport()}>
          {intl.formatMessage({ id: 'pages.applications.exportToXLS.label' })}
        </MenuItem>
        <MenuItem disabled={!totalElements} onClick={() => handleExportAllRequest()}>
          {intl.formatMessage({ id: 'pages.applications.exportAllToXLS.label' })}
        </MenuItem>
        {userRole === 'delegado' && (
          <MenuItem disabled={!selectedRows.length} onClick={() => handleOpenModal('assignTo')}>
            {intl.formatMessage({ id: 'pages.applications.assignButton.label' })}
          </MenuItem>
        )}
      </Menu>
    </Box>
  )
}
